/**
 * @param {{STRING}} searchType  /maf   ||   ///
 * @param {{STRING}} searchTerm  /// pizza.beep.sports
 * @var {{FUNCTION}} w3wInputHelper parse searchTerm using loop and regex
 * @var {{FUNCTION}} isValidADRSearchTerm check searchTerm for scheme 'tel'
 */

export const w3wInputHelper = (searchType, searchTerm) => {
  const alphaRegex = /^[a-zA-Z]+$/i;
  let cleanTerm = searchTerm.trim();
  if (searchTerm.includes(searchType)) {
    cleanTerm = searchTerm.split(searchType)[1].trim();
  }
  let parsedTerm = '';
  let spaceOrDots = 0;
  let wordCount = 0;
  let wasSpaceOrDots = false;

  for (let i = 0; i < cleanTerm.length; i++) {
    let char = cleanTerm[i];
    if (char === ' ' || char === '.') {
      if (!wasSpaceOrDots) {
        parsedTerm += '.';
        spaceOrDots++;
        wordCount++;
        wasSpaceOrDots = true;
      }
    } else if (alphaRegex.test(char)) {
      parsedTerm += char;
      if (wasSpaceOrDots) {
        wasSpaceOrDots = false;
      }
    } else {
      return false;
    }
  }
  if (alphaRegex.test(parsedTerm[parsedTerm.length - 1])) {
    wordCount++;
  }
  if (spaceOrDots === 2 && wordCount === 3) {
    return parsedTerm;
  } else {
    return false;
  }
};

export const isW3WSearchTerm = searchTerm => {
  return searchTerm.includes('///');
};

export const isADRSearchTerm = searchTerm => {
  const prefix = '/';
  return searchTerm[0] === prefix && searchTerm[1] !== prefix;
};

export const isValidADRSearchTerm = searchTerm => {
  const rg = /^[0-9\s-]+$/i; // only digits and dashes
  const splitQuery = searchTerm.split('/');
  let cleanTermWithDashes = splitQuery[1].trim();
  let cleanTerm = cleanTermWithDashes.replaceAll('-', '');
  if (rg.test(cleanTerm)) {
    if (cleanTerm.length < 10 || cleanTerm.length > 11) {
      return false;
    } else {
      if (
        (cleanTerm.length === 10 && cleanTerm[0] !== '1') ||
        (cleanTerm.length === 11 && cleanTerm[0] === '1')
      ) {
        return cleanTerm;
      }
    }
  }
  return false;
};
